import { useId } from 'react';
import { DEMO_VENUES, useAuth } from '@/lib/auth';
import { FieldTooltipIcon, SelectField, fieldControlClass } from '@/components/ui/form-fields';
import { FIELD_TOOLTIPS } from '@/content/field-tooltips';
import { cn } from '@/lib/utils';

type OwnerSwitcherProps = {
  /** Single-row layout for the app header toolbar. */
  compact?: boolean;
};

export function OwnerSwitcher({ compact = false }: OwnerSwitcherProps) {
  const { apiKey, switchVenue, ready, switchingVenue } = useAuth();
  const uid = useId();
  const selectId = `venue-${uid}`;
  const tipId = `${selectId}-tip`;

  if (compact) {
    return (
      <div className="flex items-center gap-1.5">
        <label htmlFor={selectId} className="sr-only">
          Venue
        </label>
        <span className="hidden text-xs font-medium text-[var(--color-muted)] sm:inline">Venue</span>
        <FieldTooltipIcon tipId={tipId} text={FIELD_TOOLTIPS.venueOwner} align="end" />
        <select
          id={selectId}
          value={apiKey}
          disabled={!ready || switchingVenue}
          title={FIELD_TOOLTIPS.venueOwner}
          aria-describedby={tipId}
          onChange={(e) => void switchVenue(e.target.value)}
          className={cn(fieldControlClass, 'h-9 w-[6.75rem] px-2.5 py-0 text-xs sm:w-[7.25rem] sm:text-sm')}
        >
          {DEMO_VENUES.map((v) => (
            <option key={v.key} value={v.key}>
              {v.label}
            </option>
          ))}
        </select>
      </div>
    );
  }

  return (
    <SelectField
      label="Venue"
      tooltip={FIELD_TOOLTIPS.venueOwner}
      value={apiKey}
      disabled={!ready || switchingVenue}
      onChange={(e) => void switchVenue(e.target.value)}
      className="w-[9.5rem] text-sm"
    >
      {DEMO_VENUES.map((v) => (
        <option key={v.key} value={v.key}>
          {v.label}
        </option>
      ))}
    </SelectField>
  );
}
